import { FunctionComponent } from 'react'

import { Box } from '@theme-ui/components'
import { NotionRenderer } from 'react-notion-x'

import { baseColors } from '@fairhq/common'
import { NotionPage } from 'store/notion/types'

import { NotionEmbedLinks } from './NotionEmebedLinks'

interface NotionEmbedProps {
  page: NotionPage
}

export const NotionEmbed: FunctionComponent<NotionEmbedProps> = ({ page }) => (
  <Box
    sx={{
      bg: baseColors.backgroundCard,
      py: 11,
      px: 6,
      mb: 9,
      borderRadius: '8px',
      border: '1px solid',
      borderColor: baseColors.borderBackground,
    }}
    css={`
      img {
        max-width: 100%;
      }
    `}
  >
    <div>
      <NotionRenderer
        recordMap={page}
        mapPageUrl={(pageUrl: string) =>
          `https://notion.so/${pageUrl?.replace(/-/g, '')}`
        }
        components={{
          Link: NotionEmbedLinks,
          PageLink: NotionEmbedLinks,
        }}
      />
    </div>
  </Box>
)
